import React, { FC, useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { DataGrid, GridCallbackDetails, GridRowSelectionModel } from '@mui/x-data-grid';

import styles from './AvailableSensors.module.scss';
import { SensorModel } from 'pages/TimeseriesPage/SensorModel';
import { timeseriesColumns } from 'pages/TimeseriesPage/TimeseriesTable/TimeseriesTableDefinition';
import { TimeseriesCustomToolbar } from 'pages/TimeseriesPage/TimeseriesTable/TimeseriesCustomToolbar';
import { dataGridFocusStyles } from 'styles';


interface AvailableSensorsProps {
  availableSensors: SensorModel[];
  isLoading: boolean;
  onAssociate: (selectedSensors: GridRowSelectionModel) => void;
}

const AvailableSensors: FC<AvailableSensorsProps> = (props: AvailableSensorsProps) => {

  const [displayedSensors, setDisplayedSensors] = useState<SensorModel[]>([]);
  const [selectedSensors, setSelectedSensors] = useState<GridRowSelectionModel>([]);
  const [isAssociateButtonDisabled, setIsAssociateButtonDisabled] = useState(false);
  const [showNonAssociatedOnly, setShowNonAssociatedOnly] = useState(false);

  useEffect(() => {
    if (!showNonAssociatedOnly) {
      setDisplayedSensors(props.availableSensors);
    } else {
      const nonAssociatedSensors = props.availableSensors.filter(sensor => !sensor.associations?.length)
      setDisplayedSensors(nonAssociatedSensors);
    }
  }, [props.availableSensors, showNonAssociatedOnly]);

  useEffect(() => {
    setIsAssociateButtonDisabled(!selectedSensors.length);
  }, [selectedSensors]);

  const associateHandler = () => {
    props.onAssociate(selectedSensors);
  };

  const toggleHandler = () => {
    setShowNonAssociatedOnly(prevState => !prevState);
  };

  const toolbarProps = {
    tableTitle: 'Available',
    button: {
      label: 'Associate',
      disabled: isAssociateButtonDisabled,
      onClick: associateHandler,
    },
    switch: {
      isChecked: showNonAssociatedOnly,
      label: 'Non-Associated Only',
      onToggle: toggleHandler,
    }
  }

  const rowSelectionChangeHandler = (rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails) => {
    setSelectedSensors(rowSelectionModel);
  };

  return (
    <div className={styles.AvailableSensors} data-testid="AvailableSensors">
      <DataGrid
        rows={displayedSensors}
        columns={timeseriesColumns}
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: () => TimeseriesCustomToolbar(toolbarProps),
        }}
        loading={props.isLoading}
        className="project-data-grid"
        getRowId={row => row._id}
        checkboxSelection
        onRowSelectionModelChange={rowSelectionChangeHandler}
        sx={dataGridFocusStyles}
      />
    </div>
  );
}

export default AvailableSensors;
